import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import ArrowLeft from './../../images/Icons/arrow-outlined-left.svg';
import ArrowRight from './../../images/Icons/arrow-outlined-right.svg';

export function Testimonial({ depoimentos }) {
    const [currentIndex, setCurrentIndex] = useState(0);

    // Garante que se o array mudar, o �ndice seja resetado
    useEffect(() => {
        setCurrentIndex(0);
    }, [depoimentos]);

    // Se n�o houver depoimentos, n�o renderiza nada
    if (!depoimentos || depoimentos.length === 0) return null;

    const handlePrevious = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? depoimentos.length - 1 : prevIndex - 1
        );
    };

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % depoimentos.length);
    };

    // Pega o depoimento atual
    const { texto: quote, nome: author, cargo: role } = depoimentos[currentIndex];

    return (
        <div className="login-page__testimonial">
            <p className="login-page__testimonial-quote" style={{whiteSpace: 'pre-line'}}>&quot;{quote}&quot;</p>

            <div className="login-page__testimonial-author">
                <div>
                    <h3 className="login-page__testimonial-author--name" style={{ maxHeight: "20px", minHeight: "20px" }}>{author}</h3>
                    <p className="login-page__testimonial-author--role" style={{ maxHeight: "20px", minHeight: "20px" }}>{role}</p>
                </div>
                <div className="login-page__testimonial-navigation">
                    <button
                        className="login-page__testimonial-navigation--buttons"
                        style={{ backgroundImage: `url(${ArrowLeft})` }}
                        onClick={handlePrevious}
                    />
                    <button
                        className="login-page__testimonial-navigation--buttons"
                        style={{ backgroundImage: `url(${ArrowRight})` }}
                        onClick={handleNext}
                    />
                </div>
            </div>
        </div>
    );
}

Testimonial.propTypes = {
    depoimentos: PropTypes.arrayOf(
        PropTypes.shape({
            texto: PropTypes.string.isRequired,
            nome: PropTypes.string.isRequired,
            cargo: PropTypes.string.isRequired
        })
    ).isRequired
};

export default Testimonial;
